import React, { ReactNode } from "react";

import { Section } from "styles/shared";

type Props = {
  children: ReactNode;
};

export const PageHeader = (props: Props) => {
  return <Section className="pt-2">{props.children}</Section>;
};
